module.exports = __webpack_public_path__ + "static/media/3.7b4d06c2.jpg";